import React, { createContext, useContext, useState } from "react";

export interface UserInfo {
  id: string;
  name: string;
  email: string;
  avatar?: string;
}

export interface ShapeInfo {
  name: string;
  size: number; // size in KB
}

interface AppContextType {
  user: UserInfo;
  setUser: React.Dispatch<React.SetStateAction<UserInfo>>;
  shape: ShapeInfo;
  setShape: React.Dispatch<React.SetStateAction<ShapeInfo>>;
}

const defaultUser: UserInfo = {
  id: "user-1",
  name: "Guest",
  email: "guest@example.com",
};

const defaultShape: ShapeInfo = {
  name: "Untitled",
  size: 0,
};

const AppContext = createContext<AppContextType | undefined>(undefined);

export const AppProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [user, setUser] = useState<UserInfo>(defaultUser);
  const [shape, setShape] = useState<ShapeInfo>(defaultShape);

  return (
    <AppContext.Provider value={{ user, setUser, shape, setShape }}>
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error("useAppContext must be used within an AppProvider");
  }
  return context;
};
